import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // Only logout on a genuine 401 from the server, not network errors or timeouts
    if (err.response?.status === 401 && !err.code) {
      localStorage.removeItem('token');
      localStorage.removeItem('staff');
      setTimeout(() => { window.location.href = '/login'; }, 3000);
    }
    return Promise.reject(err);
  }
);

export default api;
